import React, { useState, useEffect } from "react";
// import matrix from "../data/Matrix.json";
// import plus from '../data/Plus.json';
// import ring from "../data/Ring_matrix.json";
// import tshape from "../data/T_shape.json";

import Select from "react-select";
import axios from "axios";
import { startPCellPlacement } from "./services/parametricPlacementService";
import usePlacementStore from '../store/placementStore';
import ProjectManager from "../canvas/ProjectManager";
import useParameterStore from "../store/parameterStore";
import { getPlacedPCell, updatePlacedPCellParameters } from "./store/placedPCellStore";
import { buildPCellFromPattern } from "./services/parametricCellBuilderService";
import layoutEngine from "../libraries/layoutEngine"
import { rebuildPCellFromDefinition } from "./services/pcellInterpreter";
import layerLibrary from "../canvas/LayerLibrary";
import ParametricDotsLibrary from "../libraries/ParametricDotsLibrary";
import ParametricAiPrompt from "./ParametricAiPrompt";
import FloatingParametricAiWindow from "./FloatingParametricAiWindow";
import { executeParametricAiActions } from "./services/parametricAiActionExecutor";
import LayerValueSelect from "./components/LayerValueSelect";


// import { updatePlacedPCell } from "./store/placedPCellStore";

// const designOptions = {
//   Matrix: matrix,
//   Plus: plus,
//   "Ring Matrix": ring,
//   "T-Shape": tshape,
// };
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BlanketTab = ({ topCellName, aiLaunchRequestId = 0 }) => {
  const [selectedDesign, setSelectedDesign] = useState("Matrix");
 const [params, setParams] = useState([]);
 const [designList, setDesignList] = useState([]);
 const [rawParams, setRawParams] = useState([]);  // 👈 add this
  const [selectedPattern, setSelectedPattern] = useState("Matrix");
  const { addPreviewPattern } = usePlacementStore();
  const { showOnlySelected, setShowOnlySelected } = usePlacementStore();
  const {
    parameters,
    updateParameterValue,
    globalParameters,
    localParameters,
    parameterMappings,
    setParameterMapping,
    removeParameterMapping,
  } = useParameterStore();
  const mappingOptions = [
    ...globalParameters.map((param) => ({
      parameter: param,
      sourceScope: "global",
    })),
    ...localParameters.map((param) => ({
      parameter: param,
      sourceScope: "local",
    })),
  ]
    .filter(({ parameter }) => String(parameter.name || "").trim())
    .map(({ parameter, sourceScope }) => ({
      label: String(parameter.name).trim(),
      value: `${sourceScope}:${parameter.id}`,
      sourceId: parameter.id,
      sourceName: String(parameter.name).trim(),
      sourceScope,
      sourceType: parameter.type || parameter.datatype,
    }));
const [isApplying, setIsApplying] = useState(false);
const [changesMade, setChangesMade] = useState(false); 

const [selectedPlacedPCellName, setSelectedPlacedPCellName] = useState("");
const [isCanvasPCellSelected, setIsCanvasPCellSelected] = useState(false);
const [selectedEditTab, setSelectedEditTab] = useState("manual");
const [isAiWindowOpen, setIsAiWindowOpen] = useState(false);
const [aiTargetContext, setAiTargetContext] = useState({
  cellName: "",
  patternType: "",
  parameters: [],
});
const [toolLayers, setToolLayers] = useState([]);




  // 👇 Add this after imports
const typeMap = {
  I: "int",
  F: "float",
  B: "binary",
  S: "string",
  LPP: "layer",
};

const cloneValue = (value) =>
  value && typeof value === "object"
    ? JSON.parse(JSON.stringify(value))
    : value;

const getTargetParameterName = (param = {}) =>
  param.originalName || param.name || "";

const getMappingKey = (cellName, parameterName) =>
  `${cellName}:${parameterName}`;

const getMappedSource = (mapping) => {
  if (!mapping) return null;

  const sourceRows =
    mapping.sourceScope === "global" ? globalParameters : localParameters;

  return (
    sourceRows.find((row) => row.id === mapping.sourceId) ||
    sourceRows.find(
      (row) =>
        String(row.name || "").trim() === String(mapping.sourceName || "").trim()
    ) ||
    null
  );
};

const isMappingTypeCompatible = (targetType, sourceType) =>
  targetType === sourceType ||
  (targetType === "int" && sourceType === "float") ||
  (targetType === "float" && sourceType === "int");

const getSourceValue = (source) =>
  source?.defaultValue ?? source?.defaultVal ?? source?.value;

const getSourceValueError = (source) => {
  const sourceType = source?.type || source?.datatype;
  const rawValue = getSourceValue(source);

  if (sourceType === "LPP") {
    if (
      !rawValue ||
      typeof rawValue !== "object" ||
      !String(rawValue.layer || "").trim() ||
      !String(rawValue.datatype || "").trim()
    ) {
      return "the mapped Layer value is invalid";
    }
    return "";
  }

  const value = String(rawValue ?? "").trim();

  if (!value) return "the mapped parameter has no value";
  if (sourceType === "I" && !/^-?\d+$/.test(value)) {
    return "the mapped Integer value is invalid";
  }
  if (sourceType === "F" && !/^-?(?:\d+\.\d+|\.\d+)$/.test(value)) {
    return "the mapped Float value is invalid";
  }
  if (sourceType === "B" && !/^(0|1|T|nil)$/i.test(value)) {
    return "the mapped Binary value is invalid";
  }
  if (sourceType === "S" && !/^[A-Za-z0-9_]+$/.test(value)) {
    return "the mapped String value is invalid";
  }

  return "";
};

const resolveMappedValue = (targetParam, mapping) => {
  const source = getMappedSource(mapping);
  const targetName = getTargetParameterName(targetParam);

  if (!source) {
    throw new Error(
      `Mapping for "${targetName}" references a parameter that no longer exists.`
    );
  }

  const targetType = targetParam.type;
  const sourceType = typeMap[source.type] || source.type;

  if (!isMappingTypeCompatible(targetType, sourceType)) {
    throw new Error(
      `Mapping type mismatch for "${targetName}": expected ${targetType}, got ${sourceType}.`
    );
  }

  const valueError = getSourceValueError(source);
  if (valueError) {
    throw new Error(`Cannot apply "${targetName}" because ${valueError}.`);
  }

  const rawValue = getSourceValue(source);

  if (targetType === "layer") {
    return {
      layer: rawValue.layer,
      datatype: rawValue.datatype,
    };
  }

  if (targetType === "int" || targetType === "float") {
    return parseFloat(rawValue);
  }

  if (targetType === "binary") {
    return rawValue === true ||
      rawValue === 1 ||
      rawValue === "1" ||
      String(rawValue).toUpperCase() === "T"
      ? 1
      : 0;
  }

  return String(rawValue);
};

const resolveMappedParameters = (cellName, parameterList) =>
  parameterList.map((param) => {
    const parameterName = getTargetParameterName(param);
    const mapping = parameterMappings[getMappingKey(cellName, parameterName)];

    return mapping
      ? { ...param, value: resolveMappedValue(param, mapping) }
      : { ...param };
  });

useEffect(() => {
  window.getCurrentSelectedPattern = () => selectedPattern;
}, [selectedPattern]);


  useEffect(() => {
  axios.get(`${API_BASE_URL}/parametric/designs`)
    .then(res => {
      setDesignList(res.data.designs);
    })
    .catch(err => {
      console.error("❌ Failed to fetch design list:", err);
    });
}, []);

useEffect(() => {
  let mounted = true;

  const loadToolLayers = async () => {
    try {
      await layerLibrary.ensureLoaded?.();

      const layers = layerLibrary.getAllLayers?.() || [];

      if (mounted) {
        setToolLayers(Array.isArray(layers) ? layers : []);
      }
    } catch (err) {
      console.error("❌ Failed to load tool layers for PCell dropdown:", err);
      if (mounted) setToolLayers([]);
    }
  };

  loadToolLayers();

  const refreshLayers = () => loadToolLayers();

  window.addEventListener("layers-updated", refreshLayers);
  window.addEventListener("hierarchy-updated", refreshLayers);

  return () => {
    mounted = false;
    window.removeEventListener("layers-updated", refreshLayers);
    window.removeEventListener("hierarchy-updated", refreshLayers);
  };
}, []);


useEffect(() => {
  const syncSelectedPCellFromCanvas = (e) => {
    const cellName =
      e?.detail?.cellName ||
      ProjectManager.getSelectedInstanceCell?.() ||
      "";

    if (!cellName) {
  setSelectedPlacedPCellName("");
  setIsCanvasPCellSelected(false);
  setParams([]);
  setRawParams([]);
  return;
}

    loadSelectedPlacedPCellParams(cellName);
  };

  window.addEventListener("pcell-instance-selected", syncSelectedPCellFromCanvas);
  window.addEventListener("hierarchy-updated", syncSelectedPCellFromCanvas);

  // initial sync bhi kar do
  syncSelectedPCellFromCanvas({
    detail: { cellName: ProjectManager.getSelectedInstanceCell?.() || "" },
  });

  return () => {
    window.removeEventListener("pcell-instance-selected", syncSelectedPCellFromCanvas);
    window.removeEventListener("hierarchy-updated", syncSelectedPCellFromCanvas);
  };
}, []);

useEffect(() => {
  if (!isCanvasPCellSelected || !selectedPlacedPCellName) return;

  setAiTargetContext({
    cellName: selectedPlacedPCellName,
    patternType: selectedDesign,
    parameters: rawParams.map((param) => ({
      ...param,
      value: cloneValue(param.value),
    })),
  });
}, [isCanvasPCellSelected, selectedPlacedPCellName, selectedDesign, rawParams]);

useEffect(() => {
  if (aiLaunchRequestId <= 0) return;
  setSelectedEditTab("ai");
  setIsAiWindowOpen(true);
}, [aiLaunchRequestId]);

const handleDesignChange = async (e) => {
  const selected = e.target.value;

  setSelectedPlacedPCellName("");
  setIsCanvasPCellSelected(false);

  setSelectedDesign(selected);
  setSelectedPattern(selected);
  ProjectManager.setSelectedPattern(selected);

  // ✅ dropdown pattern change hote hi uske fresh backend params load karo
  try {
    const res = await axios.get(`${API_BASE_URL}/parametric/designs/${selected}`);
    const fetchedParams = Array.isArray(res.data?.parameters)
      ? normalizeParams(res.data.parameters)
      : [];

    setParams(JSON.parse(JSON.stringify(fetchedParams)));
    setRawParams(JSON.parse(JSON.stringify(fetchedParams)));
  } catch (err) {
    console.error("❌ Failed to fetch params for selected design:", err);
    setParams([]);
    setRawParams([]);
  }

  window.canvasEngine?.draw();
};

 const handleParamChange = (index, value, { trackManualValue = true } = {}) => {
  const updated = [...params];
  updated[index].value = value;
  setParams(updated);

  const paramNameInJson = updated[index].originalName || updated[index].name;

  if (trackManualValue && selectedPlacedPCellName) {
    const mapping =
      parameterMappings[
        getMappingKey(selectedPlacedPCellName, paramNameInJson)
      ];

    if (mapping) {
      setParameterMapping(selectedPlacedPCellName, paramNameInJson, {
        ...mapping,
        manualValue: cloneValue(value),
      });
    }
  }

  const updatedRaw = rawParams.map(p => {
    if (getTargetParameterName(p) === paramNameInJson) {
      const newVal = p.type === "layer" ? value : parseFloat(value);
      return { ...p, value: newVal };
    }
    return p;
  });

  setRawParams(updatedRaw);

  // ✅ Update Zustand store too
  updateParameterValue(paramNameInJson, value);
};

// const applyChanges = async () => {
//   try {
//     setIsApplying(true);

//     await axios.post(`http://localhost:7000/api/designs/${selectedDesign}/update`, {
//       parameters: rawParams,
//     });

//     console.log("✅ Parameters updated to backend");

//     const placedCellRefName =
//   ProjectManager.getSelectedInstanceCell?.() ||
//   `${selectedDesign}_inst`;

// await replaceOnlyInstance(selectedDesign, topCellName, placedCellRefName);

//     ProjectManager.setSelectedPattern(selectedDesign);
//     window.dispatchEvent(new Event("hierarchy-updated"));
//     window.canvasEngine?.draw();

//     setChangesMade(false);
//   } catch (err) {
//     console.error("❌ Failed to apply changes:", err);
//   } finally {
//     setIsApplying(false);
//   }
// };







//   const handlePlaceClick = async () => {
//   if (!topCellName || topCellName.trim() === "") {
//     alert("❌ Please enter a Top Cell Name.");
//     return;
//   }

//   await placeParametricDesign(selectedDesign, topCellName); // ✅ actual placement
//   addPreviewPattern(selectedDesign); // ✅ add preview info for placement tab
// };

const applySelectedPCellParameters = async ({
  targetCellName,
  nextParameters,
  expectedPatternType,
}) => {
  if (!isCanvasPCellSelected || !selectedPlacedPCellName) {
    throw new Error("Please select a PCell first.");
  }

  if (!targetCellName || targetCellName !== selectedPlacedPCellName) {
    throw new Error(
      "The selected PCell changed. Generate a new proposal for the current selection."
    );
  }

  if (!Array.isArray(nextParameters) || nextParameters.length === 0) {
    throw new Error("No PCell parameter values were provided.");
  }

  const placed = getPlacedPCell(targetCellName);
  if (!placed) {
    throw new Error("Selected PCell data not found.");
  }

  if (expectedPatternType && placed.patternType !== expectedPatternType) {
    throw new Error(
      "The selected PCell pattern changed. Generate a new proposal for the current selection."
    );
  }

  setIsApplying(true);

  try {
    const proposedParams = JSON.parse(JSON.stringify(nextParameters));
    const nextParams = resolveMappedParameters(targetCellName, proposedParams);
    updatePlacedPCellParameters(targetCellName, nextParams);

    rebuildPCellFromDefinition(
      targetCellName,
      placed.definitionSnapshot,
      nextParams
    );

    setParams(JSON.parse(JSON.stringify(nextParams)));
    setRawParams(JSON.parse(JSON.stringify(nextParams)));

    const engine = window.canvasEngine;

    if (engine) {
      const parentCellName = ProjectManager.getSelectedCell?.() || topCellName;

      // ✅ First fresh dots after selected PCell resize
      ParametricDotsLibrary.redraw(engine, {
        parentCellName,
        gridSize: engine.dotGridSize || ParametricDotsLibrary.gridSize || 3,
        refresh: true,
      });

      // ✅ Selected/middle PCell resize hone ke baad uske saare connected dots maintain karo
      // connection system ko actual placed instance id chahiye
      const parentCell =
        layoutEngine.getMergedCell?.(parentCellName) ||
        layoutEngine.getCellByName?.(parentCellName) ||
        layoutEngine.getUploadedCell?.(parentCellName);

      const changedInstance = (parentCell?.instances || []).find(
        (inst) => inst.ref === targetCellName
      );

      if (changedInstance?.id) {
        ParametricDotsLibrary.maintainConnectionsForChangedInstance(
          engine,
          parentCellName,
          changedInstance.id
        );
      } else {
        console.warn("⚠️ Changed PCell instance not found for connection maintain:", {
          parentCellName,
          selectedPlacedPCellName: targetCellName,
          instances: parentCell?.instances || [],
        });
      }

      // ✅ Final fresh dots
      ParametricDotsLibrary.redraw(engine, {
        parentCellName,
        gridSize: engine.dotGridSize || ParametricDotsLibrary.gridSize || 3,
        refresh: true,
      });

      ParametricDotsLibrary.applyToEngine(engine);
    }

    window.dispatchEvent(new Event("hierarchy-updated"));
    engine?.draw?.();

    return { cellName: targetCellName, parameters: nextParams };
  } finally {
    setIsApplying(false);
  }
};

const applyChanges = async () => {
  try {
    await applySelectedPCellParameters({
      targetCellName: selectedPlacedPCellName,
      nextParameters: rawParams,
    });
  } catch (err) {
    console.error("❌ Failed to apply PCell changes:", err);
    alert(err.message || "Failed to apply changes");
  }
};

const applyAiProposal = async ({
  cellName,
  patternType,
  proposedParameters,
}) => {
  try {
    return await applySelectedPCellParameters({
      targetCellName: cellName,
      nextParameters: proposedParameters,
      expectedPatternType: patternType,
    });
  } catch (err) {
    console.error("❌ Failed to apply AI PCell proposal:", err);
    throw err;
  }
};

const applyAiActions = async ({
  cellName,
  patternType,
  actions,
}) => {
  if (
    cellName !== aiTargetContext.cellName ||
    patternType !== aiTargetContext.patternType
  ) {
    throw new Error(
      "The AI target changed. Send the instruction again for the current target."
    );
  }

  return executeParametricAiActions({
    actions,
    selectedCellName: cellName,
  });
};

const loadSelectedPlacedPCellParams = (cellName) => {
  console.log("selected cellName =>", cellName);

  if (!cellName) {
    setSelectedPlacedPCellName("");
    setIsCanvasPCellSelected(false);
    setParams([]);
    setRawParams([]);
    return false;
  }

  const placed = getPlacedPCell(cellName);
  console.log("placed pcell =>", placed);

  if (!placed) {
    setSelectedPlacedPCellName("");
    setIsCanvasPCellSelected(false);
    setParams([]);
    setRawParams([]);
    return false;
  }

  setSelectedPlacedPCellName(cellName);
  setIsCanvasPCellSelected(true);

  if (placed.patternType) {
    setSelectedDesign(placed.patternType);
    setSelectedPattern(placed.patternType);
    ProjectManager.setSelectedPattern?.(placed.patternType);
  }

  const clonedParams = JSON.parse(JSON.stringify(placed.parameters || []));
  console.log("clonedParams =>", clonedParams);

  setParams(clonedParams);
  setRawParams(clonedParams);

  return true;
};

const handlePlaceClick = async () => {
  try {
    // ✅ hamesha selected dropdown pattern ke params backend se lo
    const res = await axios.get(`${API_BASE_URL}/parametric/designs/${selectedDesign}`);
    const fetchedParams = Array.isArray(res.data?.parameters)
      ? normalizeParams(res.data.parameters)
      : [];

    const paramsToStore = JSON.parse(JSON.stringify(fetchedParams));

    setParams(paramsToStore);
    setRawParams(paramsToStore);

    const result = await startPCellPlacement({
      patternType: selectedDesign,
      topCellName,
      parameters: paramsToStore,
      isDraftPreview: true,
      onPlacedPreview: (cellName) => {
        addPreviewPattern(cellName);
      },
    });

    console.log("✅ PCell placement started:", result);
  } catch (err) {
    console.error("❌ Failed to start PCell placement:", err);
    alert(err.message || "Failed to start placement");
  }
};

const getParameterMapping = (param) => {
  if (!selectedPlacedPCellName) return null;

  return (
    parameterMappings[
      getMappingKey(selectedPlacedPCellName, getTargetParameterName(param))
    ] || null
  );
};

const getSelectedMappingOption = (param) => {
  const mapping = getParameterMapping(param);
  if (!mapping) return null;

  return (
    mappingOptions.find(
      (option) =>
        option.sourceScope === mapping.sourceScope &&
        option.sourceId === mapping.sourceId
    ) || {
      label: mapping.sourceName || "Missing parameter",
      value: `${mapping.sourceScope}:${mapping.sourceId}`,
      sourceId: mapping.sourceId,
      sourceName: mapping.sourceName,
      sourceScope: mapping.sourceScope,
    }
  );
};

const isParameterMappingInvalid = (param) => {
  const mapping = getParameterMapping(param);
  if (!mapping) return false;

  const source = getMappedSource(mapping);
  if (!source) return true;

  const sourceType = typeMap[source.type] || source.type;
  return (
    !isMappingTypeCompatible(param.type, sourceType) ||
    Boolean(getSourceValueError(source))
  );
};

const handleMappingChange = (param, index, selectedOption) => {
  const parameterName = getTargetParameterName(param);
  const existingMapping = getParameterMapping(param);

  if (!selectedOption) {
    const fallbackValue = Object.prototype.hasOwnProperty.call(
      existingMapping || {},
      "manualValue"
    )
      ? cloneValue(existingMapping.manualValue)
      : cloneValue(param.value);

    removeParameterMapping(selectedPlacedPCellName, parameterName);
    handleParamChange(index, fallbackValue, { trackManualValue: false });
    return;
  }

  const sourceRows =
    selectedOption.sourceScope === "global"
      ? globalParameters
      : localParameters;
  const source = sourceRows.find(
    (row) => row.id === selectedOption.sourceId
  );

  const nextMapping = {
    sourceScope: selectedOption.sourceScope,
    sourceId: selectedOption.sourceId,
    sourceName: selectedOption.sourceName,
    manualValue: Object.prototype.hasOwnProperty.call(
      existingMapping || {},
      "manualValue"
    )
      ? cloneValue(existingMapping.manualValue)
      : cloneValue(param.value),
  };

  setParameterMapping(selectedPlacedPCellName, parameterName, nextMapping);

  if (!source) return;

  const sourceType = typeMap[source.type] || source.type;
  if (!isMappingTypeCompatible(param.type, sourceType)) {
    console.warn(
      `❌ Type mismatch: expected "${param.type}" but got "${sourceType}"`
    );
    return;
  }

  const valueError = getSourceValueError(source);
  if (valueError) {
    console.warn(`❌ Invalid mapped value for "${parameterName}": ${valueError}`);
    return;
  }

  handleParamChange(index, resolveMappedValue(param, nextMapping), {
    trackManualValue: false,
  });
};



// useEffect(() => {
//   const handleInstancePlaced = async (e) => {
//     const placedRef = e.detail?.ref;
//     const currentPreviewRef = ProjectManager.getSelectedInstanceCell?.();

//     if (!placedRef || !currentPreviewRef || placedRef !== currentPreviewRef) {
//       return;
//     }

//     if (window.ToolManager?.getCurrentTool?.() !== "instance") {
//       return;
//     }

//     // jo preview wala cell actual place ho gaya, ab wo draft nahi raha
//     updatePlacedPCell(placedRef, {
//       isDraftPreview: false,
//     });

//     try {
//       const result = await startPCellPlacement({
//         patternType: selectedDesign,
//         topCellName,
//         parameters: rawParams,
//         isDraftPreview: true,
//         onPlacedPreview: (cellName) => {
//           addPreviewPattern(cellName);
//         },
//       });

//       console.log("✅ Auto-prepared next PCell placement:", result);
//     } catch (err) {
//       console.error("❌ Failed to auto-prepare next PCell placement:", err);
//     }
//   };

//   window.addEventListener("instance-placed", handleInstancePlaced);
//   return () => {
//     window.removeEventListener("instance-placed", handleInstancePlaced);
//   };
// }, [selectedDesign, topCellName, rawParams, addPreviewPattern]);
return (

  
  <div style={{ padding: "10px", color: "#eee", fontSize: "13px" }}>
   <div style={patternToolbarStyle}>
  <select style={{ ...dropdownStyle, width: "100%" }} onChange={handleDesignChange} value={selectedDesign}>
    {designList.map((name) => (
      <option key={name} value={name}>{name}</option>
    ))}
  </select>

  <button
    type="button"
    role="switch"
    aria-checked={showOnlySelected}
    aria-label="Show only selected PCell"
    title={
      isCanvasPCellSelected || showOnlySelected
        ? "Show only the selected PCell"
        : "Select a PCell first"
    }
    disabled={!isCanvasPCellSelected && !showOnlySelected}
    onClick={() => {
      if (!showOnlySelected && !selectedPlacedPCellName) return;

      const nextValue = !showOnlySelected;
      setShowOnlySelected(nextValue, selectedPlacedPCellName);
      ProjectManager.setShowOnlySelected(nextValue);
      window.canvasEngine?.draw();
    }}
    style={selectedOnlyToggleStyle(
      showOnlySelected,
      !isCanvasPCellSelected && !showOnlySelected
    )}
  >
    <span style={selectedOnlyLabelStyle}>Only selected</span>
    <span style={selectedOnlyTrackStyle(showOnlySelected)}>
      <span style={selectedOnlyThumbStyle(showOnlySelected)} />
    </span>
  </button>

  <button
  disabled={!isCanvasPCellSelected || !selectedPlacedPCellName || rawParams.length === 0 || isApplying}
  style={{
    backgroundColor: "#4caf50",
    color: "#fff",
    width: "100%",
    minWidth: 0,
    height: "38px",
    padding: "7px 8px",
    border: "none",
    borderRadius: "7px",
    fontWeight: "bold",
    fontSize: "12px",
    lineHeight: 1.1,
    boxSizing: "border-box",
    cursor:
      !isCanvasPCellSelected || !selectedPlacedPCellName || rawParams.length === 0 || isApplying
        ? "not-allowed"
        : "pointer",
    opacity:
      !isCanvasPCellSelected || !selectedPlacedPCellName || rawParams.length === 0 || isApplying
        ? 0.5
        : 1
  }}
  onClick={applyChanges}
>
  {isApplying ? "Applying..." : "Apply Changes"}
</button>

  <div style={{ width: "30px" }}>
    <button
      onClick={handlePlaceClick}
      style={{ ...iconBtn, width: "30px", height: "38px", padding: 0 }}
      title="Place PCell"
    >
      ⮞
    </button>
  </div>
</div>

{isCanvasPCellSelected && selectedPlacedPCellName && (
  <>
    <div
      style={{
        marginBottom: "6px",
        padding: "6px 8px",
        border: "1px solid #555",
        borderRadius: "4px",
        background: "#1f1f1f",
        color: "#7CFC00",
        fontSize: "12px",
        fontWeight: "bold",
      }}
    >
      Selected PCell: {selectedPlacedPCellName}
    </div>

    <div role="tablist" aria-label="PCell editing mode" style={editorTabsStyle}>
      <button
        type="button"
        role="tab"
        aria-selected={selectedEditTab === "manual"}
        onClick={() => {
          setSelectedEditTab("manual");
          setIsAiWindowOpen(false);
        }}
        style={editorTabStyle(selectedEditTab === "manual")}
      >
        Manual
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={isAiWindowOpen}
        onClick={() => {
          setSelectedEditTab("ai");
          setIsAiWindowOpen(true);
        }}
        style={editorTabStyle(isAiWindowOpen)}
      >
        With AI
      </button>
    </div>

  </>
)}

<FloatingParametricAiWindow
  open={isAiWindowOpen}
  targetName={aiTargetContext.cellName}
  onClose={() => {
    setIsAiWindowOpen(false);
    setSelectedEditTab("manual");
  }}
>
  <ParametricAiPrompt
    patternType={aiTargetContext.patternType}
    cellName={aiTargetContext.cellName}
    currentParameters={aiTargetContext.parameters}
    onConfirmApply={applyAiProposal}
    onConfirmActions={applyAiActions}
    availableLayers={toolLayers}
    isActive={isAiWindowOpen}
    disabled={isApplying}
    fillContainer
    showHeader={false}
    largeComposer
  />
</FloatingParametricAiWindow>

{(!isCanvasPCellSelected || selectedEditTab === "manual" || isAiWindowOpen) && (
<>
{/* 🔥 PRO UI: Corrected Header - Puraana duplicate hata diya gaya hai */}
<div style={{
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "6px 0",
  marginBottom: "8px",
  borderBottom: "1px solid #555",
  fontWeight: "bold",
  fontSize: "12px",
  color: "#00bcd4"
}}>
  <div style={{ width: "195px", paddingLeft: "4px", flexShrink: 0 }}>Binding / Parameter</div>
  <div style={{ flex: 1, display: "flex", gap: "8px", paddingRight: "4px", minWidth: 0 }}>
    <span style={{ width: "50px", textAlign: "center", flexShrink: 0 }}>Val</span>
    <span style={{ width: "50px", textAlign: "center", flexShrink: 0 }}>Step</span>
    <span style={{ flex: 1, textAlign: "center", minWidth: 0 }}>Slider</span>
  </div>
</div>

{!isCanvasPCellSelected ? (
  <div
    style={{
      padding: "10px",
      marginBottom: "10px",
      border: "1px solid #555",
      borderRadius: "4px",
      background: "#1f1f1f",
      color: "#ffb74d",
      fontSize: "12px",
      textAlign: "center",
    }}
  >
    PCell object is not selected.
  </div>
) : (
  <>
    {params.map((param, i) => (
      <div key={i} style={{ display: "flex", alignItems: "center", marginBottom: "8px", gap: "8px" }}>
        
        {/* 🔥 Left Section (Dropdown + Parameter Name Badge) */}
        <div style={{ display: "flex", alignItems: "center", gap: "6px", width: "195px", flexShrink: 0 }}>
          
          <div style={{ width: "95px", flexShrink: 0 }}> 
            <Select
              isSearchable
              isClearable
              options={
                param.type === "layer"
                  ? mappingOptions.filter(
                      (option) => option.sourceType === "LPP"
                    )
                  : mappingOptions
              }
              value={getSelectedMappingOption(param)}
              onChange={(selectedOption) =>
                handleMappingChange(param, i, selectedOption)
              }
              styles={{
                container: (base) => ({ ...base, width: "100%" }),
                control: (base) => {
                  const isMismatch = isParameterMappingInvalid(param);

                  return {
                    ...base,
                    backgroundColor: "#2a2a2a",
                    borderColor: isMismatch ? "#ff3b3b" : "#444",
                    borderWidth: isMismatch ? "2px" : "1px",
                    minHeight: "26px", 
                    height: "26px",
                    boxShadow: "none",
                    cursor: "pointer",
                    borderRadius: "3px",
                    "&:hover": { borderColor: isMismatch ? "#ff3b3b" : "#888" },
                  };
                },
                valueContainer: (base) => ({
                  ...base,
                  padding: "0px 4px", 
                  height: "24px",
                  minHeight: "24px",
                }),
                input: (base) => ({ ...base, color: "#fff", margin: "0px", padding: "0px", fontSize: "11px" }),
                singleValue: (base) => ({ ...base, color: "#fff", fontSize: "11px" }),
                indicatorsContainer: (base) => ({ ...base, height: "24px" }),
                dropdownIndicator: (base) => ({
                  ...base,
                  padding: "2px", 
                  color: "#888",
                  svg: { width: "10px", height: "10px" }, 
                  "&:hover": { color: "#fff" },
                }),
                clearIndicator: (base) => ({
                  ...base,
                  padding: "2px",
                  color: "#888",
                  svg: { width: "10px", height: "10px" },
                  "&:hover": { color: "#ff3b3b" },
                }),
                menu: (base) => ({ ...base, backgroundColor: "#2a2a2a", border: "1px solid #444", zIndex: 9999, width: "150px" }),
                option: (base, state) => ({ ...base, backgroundColor: state.isFocused ? "#333" : "#2a2a2a", color: "#fff", fontSize: "11px", padding: "6px 8px", cursor: "pointer" }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: "150px", 
                  "::-webkit-scrollbar": { width: "4px" },
                  "::-webkit-scrollbar-thumb": { background: "#666", borderRadius: "2px" },
                }),
              }}
            />
          </div>

          <div
            title={`Datatype: ${param.type}`}
            style={{
              flex: 1,
              fontWeight: "bold",
              fontSize: "11px",
              border: "1px solid #555",
              backgroundColor: "#1e1e1e",
              color: "#ffca28", // Golden accent for parameter name
              height: "26px", 
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "3px",
              padding: "0 4px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              boxSizing: "border-box",
              minWidth: 0
            }}
          >
            {param.displayName || param.name}
          </div>
        </div>

        {/* 🔥 Right Section (Inputs & Sliders locked with minWidth: 0 to prevent blowout) */}
        <div style={{ flex: 1, display: "flex", gap: "8px", alignItems: "center", minWidth: 0 }}>
          {param.type === "layer" ? (
            <LayerValueSelect
              layers={toolLayers}
              value={param.value}
              onChange={(value) => handleParamChange(i, value)}
              height={26}
              alignMenuRight
            />
          ) : param.type === "binary" ? (
            <label className="switch" style={{ flexShrink: 0 }}>
              <input type="checkbox" checked={Boolean(param.value)} onChange={(e) => handleParamChange(i, e.target.checked ? 1 : 0)} />
              <span className="slider round"></span>
            </label>
          ) : (
            <>
              <input
                type="number"
                value={param.value}
                onChange={(e) => handleParamChange(i, parseFloat(e.target.value))}
                style={{ ...inputStyle, width: "50px", fontSize: "11px", height: "26px", padding: "0", textAlign: "center", boxSizing: "border-box", flexShrink: 0 }}
              />

              <input
                type="number"
                value={param.step_size}
                onChange={(e) => {
                  const updated = [...params];
                  updated[i].step_size = e.target.value;
                  setParams(updated);
                  const paramNameInJson = updated[i].originalName || updated[i].name;
                  const updatedRaw = rawParams.map(p => p.name === paramNameInJson ? { ...p, step_size: e.target.value } : p);
                  setRawParams(updatedRaw);
                }}
                placeholder="step"
                style={{ ...inputStyle, width: "50px", fontSize: "11px", height: "26px", padding: "0", textAlign: "center", boxSizing: "border-box", flexShrink: 0 }}
              />

              {/* 🔥 FIX: minWidth: 0 prevents slider from blowing out bounds */}
              <input
                type="range"
                min="0"
                max="200"
                step={param.step_size}
                value={param.value}
                onChange={(e) => handleParamChange(i, parseFloat(e.target.value))}
                style={{ flex: 1, height: "14px", minWidth: 0, width: "100%", cursor: "pointer" }}
              />
            </>
          )}
        </div>
      </div>
    ))}
  </>
)}

</>
)}

   
  </div>
);
}
  
function normalizeParams(params) {
  return params.map((p) => ({
    ...p,
    value:
      p.type === "layer"
        ? (p.value || { layer: "", datatype: "" })
        : (Number.isFinite(parseFloat(p.value)) ? parseFloat(p.value) : 0),
    step_size: Number.isFinite(parseFloat(p.step_size)) ? parseFloat(p.step_size) : 1,
    originalName: p.name,
  }));
}



function generateStepOptions(param) {
  const max = 200;
  const step = parseFloat(param.step_size);
  const options = [];
  for (let i = 0; i <= max; i += step) {
    options.push(parseFloat(i.toFixed(2)));
  }
  return options;
}

const inputStyle = {
  backgroundColor: "#2a2a2a",
  color: "#fff",
  border: "1px solid #444",
  borderRadius: "3px",
  padding: "6px",
  fontSize: "13px",
};

const dropdownStyle = {
  ...inputStyle,
  width: "140px",
};

const patternToolbarStyle = {
  display: "grid",
  gridTemplateColumns: "95px minmax(112px, 1fr) 100px 30px",
  alignItems: "center",
  gap: "6px",
  marginBottom: "10px",
};

const editorTabsStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "4px",
  marginBottom: "9px",
  padding: "3px",
  border: "1px solid #3e4b50",
  borderRadius: "7px",
  background: "#171d20",
};

const editorTabStyle = (active) => ({
  height: "29px",
  padding: "0 10px",
  border: active ? "1px solid #37b9c8" : "1px solid transparent",
  borderRadius: "5px",
  color: active ? "#071315" : "#aebdc1",
  background: active ? "#55d8e6" : "transparent",
  fontSize: "11px",
  fontWeight: 700,
  cursor: "pointer",
  transition: "border-color 0.16s ease, background 0.16s ease, color 0.16s ease",
});

const selectedOnlyToggleStyle = (active, disabled) => ({
  height: "38px",
  minWidth: 0,
  padding: "0 6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "5px",
  borderRadius: "7px",
  border: active
    ? "1px solid rgba(0, 188, 212, 0.9)"
    : "1px solid #4a4a4a",
  background: active
    ? "linear-gradient(180deg, rgba(0, 188, 212, 0.18), rgba(0, 188, 212, 0.08))"
    : "linear-gradient(180deg, #2b2b2b, #232323)",
  color: active ? "#8cecff" : "#d3d3d3",
  boxShadow: active
    ? "0 0 0 1px rgba(0, 188, 212, 0.08), 0 4px 12px rgba(0, 0, 0, 0.22)"
    : "0 3px 10px rgba(0, 0, 0, 0.18)",
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.5 : 1,
  transition: "border-color 0.18s ease, background 0.18s ease, color 0.18s ease",
  boxSizing: "border-box",
});

const selectedOnlyLabelStyle = {
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: "10px",
  fontWeight: 600,
};

const selectedOnlyTrackStyle = (active) => ({
  position: "relative",
  width: "28px",
  height: "16px",
  flexShrink: 0,
  borderRadius: "999px",
  backgroundColor: active ? "#00bcd4" : "#555",
  boxShadow: active ? "0 0 8px rgba(0, 188, 212, 0.42)" : "none",
  transition: "background-color 0.18s ease, box-shadow 0.18s ease",
});

const selectedOnlyThumbStyle = (active) => ({
  position: "absolute",
  top: "2px",
  left: active ? "14px" : "2px",
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  backgroundColor: "#fff",
  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.45)",
  transition: "left 0.18s ease",
});

const iconBtn = {
  backgroundColor: "#222",
  border: "1px solid #00bcd4",
  color: "#00bcd4",
  padding: "4px 8px",
  fontSize: "14px",
  borderRadius: "4px",
  cursor: "pointer",
};

const labelStyle = {
  display: "block",
  marginBottom: "4px",
  fontSize: "13px",
};




export default BlanketTab;
